module.exports = __webpack_public_path__ + "static/TMD intraoral after-5c2638f8c784f21a5447dfa984fd452c.jpg";